import { type Schema, SchemaType } from "@ext/markdown/core/render/logic/Markdoc";
import AttributeFormatter from "@ext/markdown/elements/view/render/logic/attributesFormatter";
import { Display } from "@ext/properties/models/display";
import Tag from "../../../../core/render/logic/Markdoc/src/ast/tag";

export const view: Schema = {
	render: "View",
	attributes: {
		defs: { type: String },
		orderby: { type: String },
		groupby: { type: String },
		select: { type: String },
		display: { type: String },
	},
	type: SchemaType.block,
	transform: (node) => {
		const { defs, orderby, groupby, select, display } = new AttributeFormatter().parse(node.attributes);
		// A view that names no display is a list. The renderer picks its component by this value,
		// so a view that arrives without one would show nothing at all.
		return new Tag("View", { defs: defs ?? [], orderby, groupby, select, display: display ?? Display.List });
	},
};
